<template>

  <div id="root">


    <router-view></router-view>
    <mainNavBar></mainNavBar>
  
  </div>


</template>

<script>
//  import { MessageBox } from 'mint-ui'
  import home from '../../home/home/home'
  import mine from '../../mine/mine/mine'
  import mainNavBar from '../mainNavBar'

  export default {
    name: 'root',
    data () {
      return {
        selected: '首页'
      }
    },
    components: {
      home,
      mine,
      mainNavBar
//      navbar
    },
//    watch: {
//      // 监听selected变量，当用户点击不同item的时候，将页面跳转至相应界面
//      selected (newVal, oldVal) {
//        if (newVal === '首页') {
//          this.$router.replace({path: '/home'})
//        } else if (newVal === '购物车') {
//          this.$router.replace({path: '/ShoppingCart'})
//        } else if (newVal === '我的') {
//          this.$router.replace({path: '/Mine'})
//        } else {
//          this.$router.replace({path: '/home'})
//        }
//      }
//    },
    destroyed () {
    },
    created () {
//      this.utils.alert(this.utils.isWXUA())
    },
    updated () {
//      this.setTabbarItem()
    },
    mounted () {
//      this.setTabbarItem()
    },
    methods: {
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/css/mixin';



  /*.mint-tabbar > .mint-tab-item.is-selected {*/
    /*background-color: rgba(255,0,0,0);*/
    /*color: #ff0000;*/
  /*}*/
  /*.mint-tabbar {*/
    /*height: pxToRem(110px);*/
  /*}*/
  #root {

  }

</style>



// WEBPACK FOOTER //
// root.vue?9ad03616